import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "help is-danger mb-2"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" A configuration already exists with this configuration for this worker. ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_6 = ["disabled", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfigurationForm = _resolveComponent("ConfigurationForm")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args)), ["prevent"]))
  }, [
    _createVNode(_component_ConfigurationForm, {
      onFormErrors: _cache[0] || (_cache[0] = ($event: any) => (_ctx.disabledTitle = $event)),
      "worker-version-id": _ctx.workerVersionId,
      "worker-id": _ctx.workerId,
      modelValue: _ctx.formConfiguration,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formConfiguration) = $event))
    }, null, 8, ["worker-version-id", "worker-id", "modelValue"]),
    (_ctx.parsedConfigurationExistsError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.parsedConfigurationExistsError.name)
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.parsedConfigurationExistsError.name[0]), 1))
            : _createCommentVNode("", true),
          (_ctx.parsedConfigurationExistsError.configuration)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("a", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('set-configuration', _ctx.parsedConfigurationExistsError.id)))
                }, "Use this configuration"),
                _hoisted_5
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      type: "button",
      class: "button is-success",
      disabled: _ctx.disabledTitle.length > 0 || undefined,
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args))),
      title: _ctx.disabledTitle || 'Create a new configuration'
    }, " Create ", 8, _hoisted_6)
  ], 32))
}